import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/auth.provider";
import { useEffect, useState } from "react";
import { Authority, Loading, getAccessToken } from "@dataone/lib";

export const withAuth = (
  Component: React.FC,
  authorities?: Authority[],
  byPass = false
) => {
  const AuthenticatedComponent = () => {
    const navigate = useNavigate();
    const [isAuth, setAuth] = useState(false);
    const { user, isAuthenticated, isCurrentUserLoad } = useAuth();

    useEffect(() => {
      if (
        ((!getAccessToken() || (!isAuthenticated && !isCurrentUserLoad)) &&
          !byPass) ||
        (byPass && !isAuthenticated && user)
      ) {
        if (
          !(byPass && !isAuthenticated && !user) ||
          (byPass && !isAuthenticated && user)
        )
          navigate("/auth/sign-in");
      } else {
        if (authorities) {
          const role = user?.groups[0];
          if (role) {
            if (!authorities?.includes(role)) navigate("/access-denied");
            else setAuth(true);
          }
        } else if (user || byPass) setAuth(true);
      }
    }, [isAuthenticated, user]);

    return isAuth ? <Component /> : <Loading />;
  };

  return AuthenticatedComponent;
};

export const withoutAuth = (Component: React.FC) => {
  const NotAuthenticatedComponent = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const { isAuthenticated, user } = useAuth();

    useEffect(() => {
      if (isAuthenticated)
        navigate(
          user?.groups[0] === Authority.OG_GUEST ? "/profile" : "/dashboard",
          {
            state: { openSmartSearch: true },
          }
        );
    }, [isAuthenticated, location]);

    return !isAuthenticated ? <Component /> : <Loading />;
  };

  return NotAuthenticatedComponent;
};
